"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateNow = void 0;
const dateTimeFormat_1 = require("./dateTimeFormat");
/**
 * aktualna data i czas w formacie yyyy-MM-dd HH:mm:ss
 */
function dateNow() {
    return (0, dateTimeFormat_1.dateTimeFormat)(new Date());
}
exports.dateNow = dateNow;
//# sourceMappingURL=dateNow.js.map